import React from 'react';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

const PEOPLE = { josh: 'var(--own-josh)', nick: 'var(--own-nick)', ruth: 'var(--own-ruth)' };

/**
 * A human's round initial avatar in their owner colour.
 *
 * @param {object} p
 * @param {string} [p.name]
 * @param {number} [p.size]
 * @param {string} [p.title]
 * @param {React.CSSProperties} [p.style]
 */
export function PersonAvatar({ name = '', size = 24, title, style }) {
  const k = name.toLowerCase().split(/[\s@]/)[0];
  return h('span', { title: title || name, style: { display: 'inline-grid', placeItems: 'center', width: size, height: size, borderRadius: '50%', background: PEOPLE[k] || 'var(--ava-none)', color: '#fff', border: ink(1.5), boxSizing: 'border-box', fontFamily: BODY, fontWeight: 800, fontSize: Math.round(size * .42), flex: 'none', ...style } }, (name[0] || '?').toUpperCase());
}
